/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFindReplace = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10 4a6 6 0 0 0-6 6c0 1.615.754 3.052 1.726 4.158.416.473.86.87 1.274 1.18V13h2v5H2v-2h2.715a11.17 11.17 0 0 1-.491-.521C3.046 14.139 2 12.25 2 10a8 8 0 0 1 8-8zm2-2h6v2h-2.19c.157.192.312.396.461.61C17.212 5.966 18 7.823 18 10c0 1.869-.574 3.635-1.556 5.03l6.263 6.263-1.414 1.414-6.205-6.205C13.955 17.44 12.553 18 11 18v-2c2.622 0 5-2.536 5-6 0-1.688-.612-3.156-1.371-4.248A7.55 7.55 0 0 0 14 4.963V7h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFindReplace as FindReplace };
